/**
 * Insert val into string s at the start of the first instance of substring s2.
 * @param {*} stringToReplaceIn String to insert into
 * @param {*} stringToInsertAt Substring to find in stringToReplaceIN
 * @param {*} stringToInsert The value to insert
 * @returns {String}
 */
export const insertAtSubstring = (
  stringToReplaceIn: string,
  stringToInsertAt: string,
  stringToInsert: string,
) => {
  //  WARNING - the standard String.replace() actually treats $$ (and similar) as a special
  //  sequence which can cause repeated replacements instead of single !!!
  //  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  //  So instead of replace we'll concat.
  const position = stringToReplaceIn.indexOf(stringToInsertAt);
  if (position < 0) return stringToReplaceIn;
  return (
    stringToReplaceIn.substring(0, position) +
    stringToInsert +
    stringToReplaceIn.substring(position)
  );
};

export const quoteToApostrophe = (string: string) =>
  string.replace(/'/g, "\\'").replace(/"/g, "'");

export const csvToArray = (string: string, delimiter: string) =>
  (string || '')
    .split(delimiter)
    .map((s) => s.trim())
    .filter(Boolean);
